<template>
  <div class="w-full flex flex-col">
    <div class="bg-n-950 flex items-center px-5 pb-3 gap-2">
      <l-icon name="bracket-left" class="text-v-300 cursor-pointer" @click="$emit('back')" />
      <span class="font-heading font-medium leading-4">{{ t('configuration.settings') }}</span>
    </div>
    <div class="flex-1 flex flex-col px-5 overflow-hidden pb-safe">
      <div class="flex items-center justify-between border-b border-n-700 py-4 text-sm">
        {{ t('configuration.sound-effects') }}
        <l-switch :model-value="!mute" @update:model-value="mute = !$event" />
      </div>

      <div
        v-if="isDataphoneWithPrinter"
        class="flex items-center justify-between border-b border-n-700 py-4 text-sm"
      >
        {{ t('sidemenu.use-self-printer') }}
        <l-switch v-model="useSelfPrinter" />
      </div>

      <div
        v-if="isSecondaryDisplaySupported"
        class="flex items-center justify-between border-b border-n-700 py-4 text-sm"
      >
        {{ t('configuration.customer-display') }}
        <l-switch v-model="secondaryDisplayEnabled" />
      </div>

      <div class="py-4">
        <div class="text-sm mb-2">{{ t('configuration.font-size') }}</div>
        <div class="flex items-center gap-2 py-2">
          <div class="text-[11px]">{{ t('configuration.letter-size') }}</div>
          <slider :points="[12, 14, 16, 18]" v-model="fontSize" />
          <div class="text-[18px]">{{ t('configuration.letter-size') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { LIcon, LSwitch } from '@last/core-ui/paprika'

import { useCustomerDisplay } from '@/composables/useCustomerDisplay'
import { useConfigStore } from '@/store/config'

import Slider from './Slider.vue'

defineEmits<{
  back: []
}>()

const { t } = useI18n()

const configStore = useConfigStore()
const { mute, fontSize, device, useSecondaryDisplay } = storeToRefs(configStore)

const { isSecondaryDisplaySupported, showSecondaryDisplay, hideSecondaryDisplay } =
  useCustomerDisplay()

const useSelfPrinter = computed({
  get: () => !!device.value.useSelfPrinter,
  set: (value: boolean) => configStore.updateHardwarePreferences({ useSelfPrinter: value })
})

const secondaryDisplayEnabled = computed({
  get: () => useSecondaryDisplay.value,
  set: async (value: boolean) => {
    if (value) {
      await showSecondaryDisplay()
    } else {
      await hideSecondaryDisplay()
    }
    useSecondaryDisplay.value = value
  }
})

const isDataphoneWithPrinter = computed<boolean>(() => {
  return device.value.model === 'Saturn1000F2'
})
</script>
